module.exports = __webpack_public_path__ + "static/media/logo-monechelle--squared.71c53d31.png";